import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ErrorNotFoundComponent } from './shared/components/error-not-found/error-not-found.component';
import { CabinetGuard } from './shared/guard/cabinet.guard';
import { PagesGuard } from './shared/guard/pages.guard';
import { ThankyouComponent } from './pages/thankyou/thankyou.component';
import { CheckMobileGuard } from './check-mobile.guard';

const routes: Routes = [
   {
      path: 'stock/:id',
      loadChildren: () =>
         import('./modules/stock-overview/stock-overview.module').then(
            (m) => m.StockOverviewModule
         ),
   } as any,
   {
      path: '',
      children: [
         {
            path: '',
            loadChildren: () =>
               import('./cabinet/cabinet.module').then((m) => m.CabinetModule),
            canActivate: [CabinetGuard, CheckMobileGuard],
         } as any,
      ],
   } as any,
   { path: 'thankyou', component: ThankyouComponent } as any,

   {
      path: '',
      redirectTo: '/',
      pathMatch: 'full',
      canActivate: [CheckMobileGuard],
   } as any,
   {
      path: '',
      children: [
         {
            path: 'authentication',
            loadChildren: () => import('./authentication/auth.routes').then(m => m.AUTH_ROUTES),
            
            // --- LEGACY AUTH MODULE ---
            // loadChildren: () =>
            //    import('./authentication/authentication.module').then(
            //       (m) => m.AuthenticationModule
            //    ),
         } as any,
      ],
   } as any,
   {
      path: '',
      children: [
         {
            path: 'pages',
            loadChildren: () =>
               import('./pages/pages.module').then((m) => m.pagesModule),
            canActivate: [PagesGuard, CheckMobileGuard],
         } as any,
      ],
   } as any,

   //  {
   //   path: 'report',
   //   component: ScreenerReportComponent
   // } as any),

   //  {
   //   path: 'report',
   //   component: ScreenerReportComponent
   // } as any),
   { path: '**', component: ErrorNotFoundComponent } as any,
];

@NgModule({
   imports: [
      RouterModule.forRoot(routes, {
         scrollPositionRestoration: 'disabled',
         anchorScrolling: 'enabled',
         initialNavigation: 'enabledBlocking',
      }),
   ],
   exports: [RouterModule],
})
export class AppRoutingModule { }
